 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML01_COVER from '@/components/xhtml/01_Cover'
 import XHTML04_FRONTMATTER from '@/components/xhtml/04_Frontmatter'
 import XHTML02_TITLEPAGE from '@/components/xhtml/02_Titlepage'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_ACKNOWLEDGEMENTS from '@/components/xhtml/06_Acknowledgements'
 import XHTML07_LIST_OF_MAPS from '@/components/xhtml/07_List_of_Maps'
 import XHTML08_MAPS from '@/components/xhtml/08_Maps'
 import XHTML09_INTRODUCTION from '@/components/xhtml/09_Introduction'
 import XHTML10_HISTORICAL_BACKGROUND from '@/components/xhtml/10_Historical_Background'
 import XHTML11_CHAPTER01 from '@/components/xhtml/11_Chapter01'
 import XHTML12_CHAPTER02 from '@/components/xhtml/12_Chapter02'
 import XHTML13_CHAPTER03 from '@/components/xhtml/13_Chapter03'
 import XHTML14_CHAPTER04 from '@/components/xhtml/14_Chapter04'
 import XHTML15_CHAPTER05 from '@/components/xhtml/15_Chapter05'
 import XHTML16_GENERAL_ADVICE from '@/components/xhtml/16_General_Advice'
 import XHTML17_CAR_TOUR_1 from '@/components/xhtml/17_Car_Tour_1'
 import XHTML18_WALK_1 from '@/components/xhtml/18_Walk_1'
 import XHTML19_WALK_2 from '@/components/xhtml/19_Walk_2'
 import XHTML20_SOISSONS_MEMORIAL from '@/components/xhtml/20_Soissons_Memorial'
 import XHTML21_BRITISH_CEMETERIES from '@/components/xhtml/21_British_Cemeteries'
 import XHTML22_GERMAN_CEMETERIES_ASSOCIATED from '@/components/xhtml/22_German_Cemeteries_Associated'
 import XHTML23_ORDER_OF_BATTLE_OF_BRITISH_FORCES from '@/components/xhtml/23_Order_of_Battle_of_British_Forces'
 import XHTML24_ORDER_OF_BATTLE_OF_GERMAN_INFANTRY_UNITS from '@/components/xhtml/24_Order_of_Battle_of_German_Infantry_Units'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/01_Cover",
 			"name" : "xhtml/01_Cover",
 			"component" : XHTML01_COVER
 		},
 		{
 			"path" : "/xhtml/04_Frontmatter",
 			"name" : "xhtml/04_Frontmatter",
 			"component" : XHTML04_FRONTMATTER
 		},
 		{
 			"path" : "/xhtml/02_Titlepage",
 			"name" : "xhtml/02_Titlepage",
 			"component" : XHTML02_TITLEPAGE
 		},
 		{
 			"path" : "/xhtml/03_Copyright",
 			"name" : "xhtml/03_Copyright",
 			"component" : XHTML03_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_Acknowledgements",
 			"name" : "xhtml/06_Acknowledgements",
 			"component" : XHTML06_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/07_List_of_Maps",
 			"name" : "xhtml/07_List_of_Maps",
 			"component" : XHTML07_LIST_OF_MAPS
 		},
 		{
 			"path" : "/xhtml/08_Maps",
 			"name" : "xhtml/08_Maps",
 			"component" : XHTML08_MAPS
 		},
 		{
 			"path" : "/xhtml/09_Introduction",
 			"name" : "xhtml/09_Introduction",
 			"component" : XHTML09_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/10_Historical_Background",
 			"name" : "xhtml/10_Historical_Background",
 			"component" : XHTML10_HISTORICAL_BACKGROUND
 		},
 		{
 			"path" : "/xhtml/11_Chapter01",
 			"name" : "xhtml/11_Chapter01",
 			"component" : XHTML11_CHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js